import { Chip, Stack } from '@mui/material';
import styled from 'styled-components';

import getContrastTextColor from '../../utils/common/getContrastTextColor';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const ContentContainer = styled(Stack)`
  width: 100%;
  max-width: 720px;
`;

const BreadcrumbsContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

interface TopicChipProps {
  $color?: string;
}

const TopicChip = styled(Chip)<TopicChipProps>`
  && {
    background-color: ${({ $color, theme }) => ($color || theme.palette.backdrop.dark)};
    color: ${({ $color, theme }) => ($color ? getContrastTextColor($color) : theme.palette.backdrop.contrastText)};
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;

const AlertContainer = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export { PageContainer, BreadcrumbsContainer, ContentContainer, TopicChip, AlertContainer };
